import {
  DeleteApiAuthBySessionIdApiArg,
  DeleteApiAuthBySessionIdApiResponse,
  PostApiAuthAuthorizationApiArg,
  PostApiAuthAuthorizationApiResponse,
  PostApiAuthUpdateTokensApiArg,
  PostApiAuthUpdateTokensApiResponse,
} from "@entities/auth";
import {
  DeleteApiAchievementsByIdApiArg,
  DeleteApiAchievementsByIdApiResponse,
  PostApiAchievementsApiArg,
  PostApiAchievementsApiResponse,
  PutApiAchievementsByIdApiArg,
  PutApiAchievementsByIdApiResponse,
} from "@entities/achivments";
import {
  PostApiPersonalAchievementsApiArg,
  PostApiPersonalAchievementsApiResponse,
  PutApiPersonalAchievementsByIdApiArg,
  PutApiPersonalAchievementsByIdApiResponse,
} from "@entities/personal_achivments";
import {
  GetApiChatByIdApiArg,
  GetApiChatByIdApiResponse,
} from "@entities/chat";
import {
  GetApiCommunitiesApiArg,
  GetApiCommunitiesApiResponse,
  GetApiCommunitiesByIdApiArg,
  GetApiCommunitiesByIdApiResponse,
  GetApiCommunitiesIconApiArg,
  GetApiCommunitiesIconApiResponse,
} from "@entities/communities";
import {
  PostApiGeolocationApiArg,
  PostApiGeolocationApiResponse,
} from "@entities/geolocation";
import {
  GetApiHobbiesApiArg,
  GetApiHobbiesApiResponse,
} from "@entities/hobbies";
import {
  GetApiInterestsApiArg,
  GetApiInterestsApiResponse,
} from "@entities/interests";
import {
  DeleteApiPhotosByIdApiArg,
  DeleteApiPhotosByIdApiResponse,
  GetApiPhotosByIdApiArg,
  GetApiPhotosByIdApiResponse,
  PostApiPhotosApiArg,
  PostApiPhotosApiResponse,
  PostApiPhotosLinkApiArg,
  PostApiPhotosLinkApiResponse,
} from "@entities/photos";
import {
  DeleteApiProfessionalExperienceByIdApiArg,
  DeleteApiProfessionalExperienceByIdApiResponse,
  GetApiProfessionalExperienceCompaniesApiArg,
  GetApiProfessionalExperienceCompaniesApiResponse,
  PostApiProfessionalExperienceApiArg,
  PostApiProfessionalExperienceApiResponse,
  PutApiProfessionalExperienceByIdApiArg,
  PutApiProfessionalExperienceByIdApiResponse,
} from "@entities/professional-experience";
import {
  GetApiProfileApiArg,
  GetApiProfileApiResponse,
  GetApiProfileDaysStreakApiArg,
  GetApiProfileDaysStreakApiResponse,
  PutApiProfileApiArg,
  PutApiProfileApiResponse,
} from "@entities/profile";
import {
  GetApiRatingApiArg,
  GetApiRatingApiResponse,
  PostApiRatingApiArg,
  PostApiRatingApiResponse,
} from "@entities/rating";
import {
  DeleteApiReactionsNewByIdApiArg,
  DeleteApiReactionsNewByIdApiResponse,
  GetApiReactionsNewApiArg,
  GetApiReactionsNewApiResponse,
  PostApiReactionsApiArg,
  PostApiReactionsApiResponse,
  PutApiReactionsByIdApiArg,
  PutApiReactionsByIdApiResponse,
} from "@entities/reactions";
import {
  GetApiRussianCitiesApiArg,
  GetApiRussianCitiesApiResponse,
} from "@entities/russian-cities";
import { GetApiSkillsApiArg, GetApiSkillsApiResponse } from "@entities/skills";
import {
  DeleteApiTasksByIdApiArg,
  DeleteApiTasksByIdApiResponse,
  GetApiTasksApiArg,
  GetApiTasksApiResponse,
  GetApiTasksUserByUserIdApiArg,
  GetApiTasksUserByUserIdApiResponse,
  PostApiTasksApiArg,
  PostApiTasksApiResponse,
  PutApiTasksByIdApiArg,
  PutApiTasksByIdApiResponse,
  PutApiTasksByTaskIdUserAndUserIdApiArg,
  PutApiTasksByTaskIdUserAndUserIdApiResponse,
} from "@entities/tasks";
import {
  GetApiUserFeedAiApiResponse,
  GetApiUserFeedAiRecommendationsApiResponse,
  GetApiUserFeedLikeApiArg,
  GetApiUserFeedLikeApiResponse,
  GetApiUserFeedMatchedApiArg,
  GetApiUserFeedMatchedApiResponse,
  PostApiUserFeedAiApiArg,
  PostApiUserFeedAiRecommendationsApiArg,
  PostApiUserFeedApiArg,
  PostApiUserFeedApiResponse,
} from "@entities/user-feed";
import {
  GetApiUsersApiArg,
  GetApiUsersApiResponse,
  GetApiUsersByIdApiArg,
  GetApiUsersByIdApiResponse,
} from "@entities/users";
import {
  DeleteApiWalletsByIdApiArg,
  DeleteApiWalletsByIdApiResponse,
  GetApiWalletsApiArg,
  GetApiWalletsApiResponse,
  PostApiWalletsApiArg,
  PostApiWalletsApiResponse,
  PutApiWalletsByIdApiArg,
  PutApiWalletsByIdApiResponse,
} from "@entities/wallets";
import {
  PostApiReferralSystemApiArg,
  GetApiReferralSystemLinkApiResponse,
  GetApiReferralSystemUsersApiResponse,
} from "@entities/referral-system";
import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiResponse } from "./api.types";
import { createBaseQueryWithReauth } from "..";
import { DeleteApiPersonalAchievementsByIdApiArg } from "@entities/personal_achivments/model/deletePersonalAchievement.types";

export const API_URL = import.meta.env.VITE_API_URL;
export const API_PREFIX = import.meta.env.VITE_API_PREFIX;

export const REDUCER_PATH = "miniAppApi";

export const miniAppApi = createApi({
  reducerPath: REDUCER_PATH,
  baseQuery: createBaseQueryWithReauth(
    API_URL + API_PREFIX,
    () => (window.location.href = "/unknownError")
  ),
  keepUnusedDataFor: 0,
  tagTypes: ["Profile", "Photos", "ReferralSystem"],
  endpoints: (build) => ({
    // auth
    authorization: build.mutation<
      ApiResponse<PostApiAuthAuthorizationApiResponse>,
      PostApiAuthAuthorizationApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/authorization`,
        method: "POST",
        body: queryArg.applicationTelegramDataDto,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    updateToken: build.mutation<
      ApiResponse<PostApiAuthUpdateTokensApiResponse>,
      PostApiAuthUpdateTokensApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/update-tokens`,
        method: "POST",
        body: queryArg.applicationUserPayload,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    logoutBySessionId: build.mutation<
      ApiResponse<DeleteApiAuthBySessionIdApiResponse>,
      DeleteApiAuthBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    // chat
    getApiChatById: build.query<
      ApiResponse<GetApiChatByIdApiResponse>,
      GetApiChatByIdApiArg
    >({
      query: (queryArg) => ({ url: `/chat/${queryArg.id}` }),
    }),
    // communities
    getApiCommunities: build.query<
      ApiResponse<GetApiCommunitiesApiResponse>,
      GetApiCommunitiesApiArg
    >({
      query: () => ({ url: `/communities` }),
    }),
    getApiCommunitiesById: build.query<
      GetApiCommunitiesByIdApiResponse,
      GetApiCommunitiesByIdApiArg
    >({
      query: (queryArg) => {
        const params = new URLSearchParams();
        if (queryArg.page !== undefined) {
          params.append("page", queryArg.page.toString());
        }
        if (queryArg.limit !== undefined) {
          params.append("limit", queryArg.limit.toString());
        }
        const queryString = params.toString();
        return {
          url: `/communities/${queryArg.id}${
            queryString ? `?${queryString}` : ""
          }`,
        };
      },
    }),

    getApiCommunitiesIcon: build.query<
      GetApiCommunitiesIconApiResponse,
      GetApiCommunitiesIconApiArg
    >({
      query: (queryArg) => ({
        url: `/communities/${queryArg.id}/icon`,
        responseType: "blob",
      }),
      transformResponse: (response: Blob) => response,
    }),
    // geolocation
    postApiGeolocation: build.mutation<
      ApiResponse<PostApiGeolocationApiResponse>,
      PostApiGeolocationApiArg
    >({
      query: (queryArg) => ({
        url: `/geolocation`,
        method: "POST",
        body: queryArg.applicationGeolocation,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    // hobbies
    getApiHobbies: build.query<
      ApiResponse<GetApiHobbiesApiResponse>,
      GetApiHobbiesApiArg
    >({
      query: (queryArg) => ({
        url: `/hobbies`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          global_search: queryArg.globalSearch,
        },
      }),
    }),
    // interests
    getApiInterests: build.query<
      ApiResponse<GetApiInterestsApiResponse>,
      GetApiInterestsApiArg
    >({
      query: (queryArg) => ({
        url: `/interests`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          global_search: queryArg.globalSearch,
        },
      }),
    }),
    // photos

    postApiPhotos: build.mutation<
      ApiResponse<PostApiPhotosApiResponse>,
      PostApiPhotosApiArg
    >({
      query: (queryArg) => ({
        url: `/photos`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: { maxRetries: 3 },
      invalidatesTags: ["Profile", "ReferralSystem"],
    }),
    postApiPhotosLink: build.mutation<
      ApiResponse<PostApiPhotosLinkApiResponse>,
      PostApiPhotosLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/photos/link`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: { maxRetries: 3 },
      invalidatesTags: ["Profile", "ReferralSystem"],
    }),
    getApiPhotosById: build.query<
      ApiResponse<GetApiPhotosByIdApiResponse>,
      GetApiPhotosByIdApiArg
    >({
      query: (queryArg) => ({ url: `/photos/${queryArg.id}` }),
    }),
    deleteApiPhotosById: build.mutation<
      ApiResponse<DeleteApiPhotosByIdApiResponse>,
      DeleteApiPhotosByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/photos/${queryArg.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Profile", "ReferralSystem"],
    }),
    // professional-experience
    postApiProfessionalExperience: build.mutation<
      ApiResponse<PostApiProfessionalExperienceApiResponse>,
      PostApiProfessionalExperienceApiArg
    >({
      query: (queryArg) => ({
        url: `/professional-experience`,
        method: "POST",
        body: queryArg.applicationProfessionalExperience,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    getApiProfessionalExperienceCompanies: build.query<
      ApiResponse<GetApiProfessionalExperienceCompaniesApiResponse>,
      GetApiProfessionalExperienceCompaniesApiArg
    >({
      query: (queryArg) => ({
        url: `/professional-experience/companies`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          rating: queryArg.rating,
          filter: queryArg.globalSearch,
        },
      }),
    }),
    putApiProfessionalExperienceById: build.mutation<
      ApiResponse<PutApiProfessionalExperienceByIdApiResponse>,
      PutApiProfessionalExperienceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/professional-experience/${queryArg.id}`,
        method: "PUT",
        body: queryArg.applicationProfessionalExperience,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    deleteApiProfessionalExperienceById: build.mutation<
      ApiResponse<DeleteApiProfessionalExperienceByIdApiResponse>,
      DeleteApiProfessionalExperienceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/professional-experience/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    // achievements
    postApiAchievements: build.mutation<
      ApiResponse<PostApiAchievementsApiResponse>,
      PostApiAchievementsApiArg
    >({
      query: (queryArg) => ({
        url: `/achievements`,
        method: "POST",
        body: queryArg.applicationAchievement,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    putApiAchievementsById: build.mutation<
      ApiResponse<PutApiAchievementsByIdApiResponse>,
      PutApiAchievementsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/achievements/${queryArg.id}`,
        method: "PUT",
        body: queryArg.applicationAchievement,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    deleteApiAchievementsById: build.mutation<
      ApiResponse<DeleteApiAchievementsByIdApiResponse>,
      DeleteApiAchievementsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/achievements/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    // personal achievements
    postApiPersonalAchievements: build.mutation<
      ApiResponse<PostApiPersonalAchievementsApiResponse>,
      PostApiPersonalAchievementsApiArg
    >({
      query: (queryArg) => ({
        url: `/personal-achievements`,
        method: "POST",
        body: queryArg.applicationPersonalAchievement,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    putApiPersonalAchievementsById: build.mutation<
      ApiResponse<PutApiPersonalAchievementsByIdApiResponse>,
      PutApiPersonalAchievementsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/personal-achievements/${queryArg.id}`,
        method: "PUT",
        body: queryArg.applicationPersonalAchievement,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    deleteApiPersonalAchievementsById: build.mutation<
      ApiResponse<DeleteApiPersonalAchievementsByIdApiArg>,
      DeleteApiPersonalAchievementsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/personal-achievements/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    // profile
    getApiProfile: build.query<
      ApiResponse<GetApiProfileApiResponse>,
      GetApiProfileApiArg
    >({
      query: () => ({ url: `/profile` }),
      providesTags: ["Profile"],
    }),
    putApiProfile: build.mutation<
      ApiResponse<PutApiProfileApiResponse>,
      PutApiProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/profile`,
        method: "PUT",
        body: queryArg.applicationUserDto,
      }),
      extraOptions: { maxRetries: 3 },

      invalidatesTags: ["Profile", "ReferralSystem"],
    }),
    getApiProfileDaysStreak: build.query<
      ApiResponse<GetApiProfileDaysStreakApiResponse>,
      GetApiProfileDaysStreakApiArg
    >({
      query: () => ({ url: `/profile/days-streak` }),
    }),
    // rating
    getApiRating: build.query<
      ApiResponse<GetApiRatingApiResponse>,
      GetApiRatingApiArg
    >({
      query: () => ({ url: `/rating` }),
    }),
    postApiRating: build.mutation<
      ApiResponse<PostApiRatingApiResponse>,
      PostApiRatingApiArg
    >({
      query: (queryArg) => ({
        url: `/rating`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    // reactions
    postApiReactions: build.mutation<
      ApiResponse<PostApiReactionsApiResponse>,
      PostApiReactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/reactions`,
        method: "POST",
        body: queryArg.body,
      }),
      extraOptions: { maxRetries: 3 },
    }),

    getApiReactionsNew: build.query<
      ApiResponse<GetApiReactionsNewApiResponse>,
      GetApiReactionsNewApiArg
    >({
      query: () => ({ url: `/reactions/new` }),
    }),
    deleteApiReactionsNewById: build.mutation<
      ApiResponse<DeleteApiReactionsNewByIdApiResponse>,
      DeleteApiReactionsNewByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/reactions/new/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putApiReactionsById: build.mutation<
      ApiResponse<PutApiReactionsByIdApiResponse>,
      PutApiReactionsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/reactions/${queryArg.id}`,
        method: "PUT",
        body: queryArg.body,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    // russian-cities
    getApiRussianCities: build.query<
      ApiResponse<GetApiRussianCitiesApiResponse>,
      GetApiRussianCitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/russian-cities`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          global_search: queryArg.globalSearch,
        },
      }),
    }),
    // skills
    getApiSkills: build.query<
      ApiResponse<GetApiSkillsApiResponse>,
      GetApiSkillsApiArg
    >({
      query: (queryArg) => ({
        url: `/skills`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          global_search: queryArg.globalSearch,
        },
      }),
    }),
    // tasks
    getApiTasks: build.query<
      ApiResponse<GetApiTasksApiResponse>,
      GetApiTasksApiArg
    >({
      query: () => ({ url: `/tasks` }),
    }),

    postApiTasks: build.mutation<
      ApiResponse<PostApiTasksApiResponse>,
      PostApiTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/api/tasks`,
        method: "POST",
        body: queryArg.applicationTask,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    getApiTasksUserByUserId: build.query<
      ApiResponse<GetApiTasksUserByUserIdApiResponse>,
      GetApiTasksUserByUserIdApiArg
    >({
      query: (queryArg) => ({ url: `/tasks/user/${queryArg.userId}` }),
    }),
    putApiTasksById: build.mutation<
      ApiResponse<PutApiTasksByIdApiResponse>,
      PutApiTasksByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tasks/${queryArg.id}`,
        method: "PUT",
        body: queryArg.applicationTask,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    deleteApiTasksById: build.mutation<
      ApiResponse<DeleteApiTasksByIdApiResponse>,
      DeleteApiTasksByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tasks/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    putApiTasksByTaskIdUserAndUserId: build.mutation<
      ApiResponse<PutApiTasksByTaskIdUserAndUserIdApiResponse>,
      PutApiTasksByTaskIdUserAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/tasks/${queryArg.taskId}/user/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.applicationTask,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    // user-feed
    postApiUserFeed: build.mutation<
      ApiResponse<PostApiUserFeedApiResponse>,
      PostApiUserFeedApiArg
    >({
      query: (queryArg) => ({
        url: `/user-feed`,
        method: "POST",
        body: queryArg.applicationUserFeedFilters,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
      extraOptions: { maxRetries: 3 },
    }),

    getApiUserFeedLike: build.query<
      ApiResponse<GetApiUserFeedLikeApiResponse>,
      GetApiUserFeedLikeApiArg
    >({
      query: (queryArg) => ({
        url: `/user-feed/like`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),

    getApiUserFeedMatched: build.query<
      ApiResponse<GetApiUserFeedMatchedApiResponse>,
      GetApiUserFeedMatchedApiArg
    >({
      query: (queryArg) => ({
        url: `/user-feed/matched`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    // users
    getApiUsers: build.query<
      ApiResponse<GetApiUsersApiResponse>,
      GetApiUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/users`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    getApiUsersById: build.query<
      ApiResponse<GetApiUsersByIdApiResponse>,
      GetApiUsersByIdApiArg
    >({
      query: (queryArg) => ({ url: `/users/${queryArg.id}` }),
    }),
    // wallets
    getApiWallets: build.query<
      ApiResponse<GetApiWalletsApiResponse>,
      GetApiWalletsApiArg
    >({
      query: () => ({ url: `/wallets` }),
    }),
    postApiWallets: build.mutation<
      ApiResponse<PostApiWalletsApiResponse>,
      PostApiWalletsApiArg
    >({
      query: (args) => ({
        url: `/wallets`,
        method: "POST",
        body: args,
      }),
      extraOptions: { maxRetries: 3 },
    }),
    putApiWalletsById: build.mutation<
      ApiResponse<PutApiWalletsByIdApiResponse>,
      PutApiWalletsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/wallets/${queryArg.id}`,
        method: "PUT",
      }),
      extraOptions: { maxRetries: 3 },
    }),
    deleteApiWalletsById: build.mutation<
      ApiResponse<DeleteApiWalletsByIdApiResponse>,
      DeleteApiWalletsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/wallets/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    // referral system
    postApiReferralSystem: build.mutation<
      ApiResponse<void>,
      PostApiReferralSystemApiArg
    >({
      query: (queryArg) => ({
        url: `/referral-system`,
        method: "POST",
        body: queryArg,
      }),
    }),

    getApiReferralSystemLink: build.query<
      ApiResponse<GetApiReferralSystemLinkApiResponse>,
      void
    >({
      query: () => ({ url: `/referral-system/link` }),
      providesTags: ["ReferralSystem"],
    }),

    getApiReferralSystemUsers: build.query<
      ApiResponse<GetApiReferralSystemUsersApiResponse>,
      void
    >({
      query: () => ({ url: `/referral-system/users` }),
      providesTags: ["ReferralSystem"],
    }),

    // user-feed/ai
    postApiUserFeedAi: build.mutation<
      GetApiUserFeedAiApiResponse,
      PostApiUserFeedAiApiArg
    >({
      query: (queryArg) => ({
        url: `/user-feed/ai`,
        method: "POST",
        body: queryArg,
      }),
    }),
    //ai-recommendations
    postApiUserFeedAiRecommendations: build.mutation<
      GetApiUserFeedAiRecommendationsApiResponse,
      PostApiUserFeedAiRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/user-feed/ai/recommendations`,
        method: "POST",
        body: queryArg,
      }),
    }),
  }),
});

export const {
  // auth
  useAuthorizationMutation,
  useUpdateTokenMutation,
  useLogoutBySessionIdMutation,
  // chat
  useGetApiChatByIdQuery,
  useLazyGetApiChatByIdQuery,
  // communities
  useGetApiCommunitiesByIdQuery,
  useLazyGetApiCommunitiesByIdQuery,
  useGetApiCommunitiesQuery,
  useGetApiCommunitiesIconQuery,

  // geolocation
  usePostApiGeolocationMutation,
  // hobbies
  useGetApiHobbiesQuery,
  // interests
  useGetApiInterestsQuery,
  // photos
  usePostApiPhotosMutation,
  usePostApiPhotosLinkMutation,
  useGetApiPhotosByIdQuery,
  useDeleteApiPhotosByIdMutation,
  // professional-experience
  usePutApiProfessionalExperienceByIdMutation,
  useGetApiProfessionalExperienceCompaniesQuery,
  usePostApiProfessionalExperienceMutation,
  useDeleteApiProfessionalExperienceByIdMutation,
  // achievements
  usePostApiAchievementsMutation,
  usePutApiAchievementsByIdMutation,
  useDeleteApiAchievementsByIdMutation,
  // personal achievements
  usePostApiPersonalAchievementsMutation,
  usePutApiPersonalAchievementsByIdMutation,
  useDeleteApiPersonalAchievementsByIdMutation,
  // profile
  useGetApiProfileDaysStreakQuery,
  useGetApiProfileQuery,
  usePutApiProfileMutation,
  // rating
  useGetApiRatingQuery,
  usePostApiRatingMutation,
  // reactions
  useGetApiReactionsNewQuery,
  usePutApiReactionsByIdMutation,
  usePostApiReactionsMutation,
  useDeleteApiReactionsNewByIdMutation,
  // russian-cities
  useGetApiRussianCitiesQuery,
  // skills
  useGetApiSkillsQuery,
  // tasks
  useGetApiTasksQuery,
  useGetApiTasksUserByUserIdQuery,
  usePutApiTasksByIdMutation,
  usePutApiTasksByTaskIdUserAndUserIdMutation,
  usePostApiTasksMutation,
  useDeleteApiTasksByIdMutation,
  // user-feed
  useGetApiUserFeedLikeQuery,
  useGetApiUserFeedMatchedQuery,
  usePostApiUserFeedMutation,
  usePostApiUserFeedAiMutation,
  // users
  useGetApiUsersQuery,
  useGetApiUsersByIdQuery,
  // wallets
  useGetApiWalletsQuery,
  usePostApiWalletsMutation,
  // referral system
  usePostApiReferralSystemMutation,
  useGetApiReferralSystemLinkQuery,
  useGetApiReferralSystemUsersQuery,
  //recommendations
  usePostApiUserFeedAiRecommendationsMutation,
} = miniAppApi;
